import React from "react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

//prime React
import { Column } from "primereact/column";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Checkbox } from "primereact/checkbox";
//components
import Select from "../../../../components/input/Select";
//services
import { useQuery } from "react-query";
import Input from "../../../../components/input/Input";
import { Accordion, AccordionTab } from "primereact/accordion";
import { getConfigSign } from "../../../../services/Enterprise/ClickSign/getConfigSign";
import { Button } from "primereact/button";
import { postConfigSign } from "../../../../services/Enterprise/ClickSign/postConfigSign";
import { Skeleton } from "primereact/skeleton";
import { postTypeSigners } from "../../../../services/Enterprise/ClickSign/postTypeSigners";
import { getTypeSigner } from "../../../../services/Enterprise/ClickSign/getTypeSinger";
import { useAppContext } from "../../../../context/AppContext";

export default function ClickSignIntegration(id) {
  const { permissions } = useAppContext();
  const [transformedData, setTransformedData] = useState([]);
  const [itemsSelected, setItemsSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    data: config_sign,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: [`config_sign${id.id}`],
    queryFn: () => getTypeSigner(id.id),
    enabled: !!permissions?.includes("90")
  });
  const {
    data: registeredIntegrations,
    refetch: refetchIntegration,
    isLoading: isLoadingIntegration,
  } = useQuery({
    queryKey: ["registeredIntegrations"],
    queryFn: () => getConfigSign(),
    enabled: !!permissions?.includes("90")
  });

  const transformedDataIntegration = registeredIntegrations
    ?.filter((item) => item.webhook === 1)
    ?.map((item) => ({
      value: item.id,
      label: item.name_token,
    }));

  const columns = [
    { field: "desc", header: "Descrição" },
    { field: "name", header: "Tipo Signatário" },
    { field: "selfie", header: "Selfie Como Ponto Autenticação" },
    {
      field: "handwritten_signature",
      header: "Assinatura Manuscrita Como Ponto de Autenticação",
    },
    {
      field: "photo_doc",
      header:
        "Foto (frente e verso) do Documento Oficial Como Ponto de Autenticação",
    },
  ];

  const type_auth = [
    { value: "sms", label: "SMS" },
    { value: "email", label: "E-mail" },
    { value: "whatsapp", label: "WhatsApp" },
  ];

  const form = useForm();
  const errors = form.formState.errors;
  const setValue = form.setValue;

  const transformData = (responseData) => {
    const { signerConfig, typeSigners } = responseData;

    const newData = typeSigners.map((signer) => {
      const config = signerConfig.find(
        (config) => config.type_signer_id === signer.id
      );

      return {
        id: signer.id,
        name: signer.name,
        desc: signer.desc,
        type: signer.type,
        id_config: config ? config.id : 0,
        selfie: config ? Boolean(config.selfie_enabled) : false,
        photo_doc: config ? Boolean(config.official_document_enabled) : false,
        handwritten_signature: config
          ? Boolean(config.handwritten_enabled)
          : false,
      };
    });

    return newData;
  };

  const updateGeneralData = (data) => {
    return data.reduce((acc, item) => {
      const transformedItem = {
        signer_id: item.id,
        selfie_enabled: item.selfie ? 1 : 0,
        official_document_enabled: item.photo_doc ? 1 : 0,
        handwritten_enabled: item.handwritten_signature ? 1 : 0,
      };
      if (
        transformedItem.selfie_enabled !== 0 ||
        transformedItem.official_document_enabled !== 0 ||
        transformedItem.handwritten_enabled !== 0
      ) {
        acc.push(transformedItem);
      }
      // console.log(acc);
      return acc;
    }, []);
  };

  function onSubmit(data) {
    setLoading(true);
    const updatedGeneralData = updateGeneralData(itemsSelected);
    let obj = {
      clicksign_config_id: data.clicksign_config_id,
      type: "enterprise",
      aux_id: id.id, //enterprise_id
      type_auth_signature_clicksign: data.type_auth,
      signers: updatedGeneralData,
    };
    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );
    let objTypeSigner = {
      enterprise_id: id.id,
      signers: updatedGeneralData,
    };

    postConfigSign(obj);
    postTypeSigners(objTypeSigner)
      .then(() => {
        refetch(); // Chamado antes do toast de sucesso
        toast.update(notification, {
          render: "Configuração de Integração feita com Sucesso!",
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      })
      .catch((error) => {
        toast.update(notification, {
          render: "Não foi possível Configurar a Integração!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao configurar integração:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleCheckboxChange = (rowData, field) => {
    const updatedRowData = { ...rowData, [field]: !rowData[field] };
    if (
      !updatedRowData.handwritten_signature &&
      !updatedRowData.photo_doc &&
      !updatedRowData.selfie
    ) {
      toast.warning("Não é permitido desmarcar todos os checkboxes!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
        theme: "colored",
      });
      return;
    }

    const updatedRowDataOne = { ...rowData };
    rowData[field] = !updatedRowDataOne[field];

    setItemsSelected((prevItemsSelected) => {
      const isSelected = prevItemsSelected.some(
        (item) => item.id === rowData.id
      );
      if (isSelected) {
        return prevItemsSelected.map((item) =>
          item.id === rowData.id ? rowData : item
        );
      } else {
        return [...prevItemsSelected, rowData];
      }
    });
  };

  useEffect(() => {
    if (config_sign && config_sign.typeSigners) {
      const newData = transformData(config_sign);
      //      console.log(newData);

      setTransformedData(newData);
      setItemsSelected(newData);

      if (config_sign && config_sign.clicksignConfig) {
        setValue(
          "clicksign_config_id",
          config_sign.clicksignConfig.clicksign_config_id
        );
        setValue(
          "type_auth",
          config_sign.clicksignConfig.type_auth_signature_clicksign
        );
      }
    }
  }, [config_sign]);

  return (
    <>
      {isLoading || isLoading ? (
        <>
          <Skeleton variant="rect" width={1000} height={200} />
        </>
      ) : (
        <>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Accordion activeIndex={0}>
              <AccordionTab
                header={
                  <div className="flex align-items-center">
                    <i className="fa-solid fa-wrench"></i>
                    <span className="mx-2 vertical-align-middle">
                      Lembrete / Integração
                    </span>
                  </div>
                }
              >
                <div className="col-md-12">
                  <h4>Informe as Chaves e tipo de Integração</h4>
                  <div className="row">
                    <div className="col-md-6 mt-4">
                      <h4>
                        {" "}
                        Chave de Integração:
                        <Tooltip target=".custom-target-icon" />
                        <i
                          className="custom-target-icon mx-2 pi 
                    pi-info-circle p-text-secondary"
                          data-pr-tooltip="Configure se a mensagem será de cobrança ou lembrete"
                          style={{ cursor: "pointer" }}
                        ></i>
                      </h4>
                      <Select
                        isRequired={true}
                        name="clicksign_config_id"
                        errors={errors}
                        disabled={isLoadingIntegration}
                        label={
                          isLoadingIntegration ? "Carregando..." : "Escolha"
                        }
                        options={transformedDataIntegration}
                        control={form.control}
                      />
                    </div>
                    <div className="col-md-6 mt-4">
                      <h4>
                        {" "}
                        Envio do Token de Autenticação
                        <Tooltip target=".custom-target-icon" />
                        <i
                          className="custom-target-icon mx-2 pi 
                    pi-info-circle p-text-secondary"
                          data-pr-tooltip="Configure se a mensagem será de cobrança ou lembrete. Obs: Para envios via WhatsApp, terão cobranças adicionais"
                          style={{ cursor: "pointer" }}
                        ></i>
                      </h4>
                      <Select
                        isRequired={true}
                        name="type_auth"
                        disabled={isLoading}
                        errors={errors}
                        label={isLoading ? "Carregando..." : "Escolha"}
                        options={type_auth}
                        control={form.control}
                      />
                    </div>
                  </div>
                </div>
              </AccordionTab>
              <AccordionTab
                header={
                  <div className="flex align-items-center">
                    <i className="fa-solid fa-gear"></i>
                    <span className="mx-2 vertical-align-middle">
                      Configurações do Tipo de Assinatura
                    </span>
                  </div>
                }
              >
                <div className="row">
                  <div className="px-2 pb-3">
                    <DataTable
                      stripedRows
                      showGridlines
                      sortMode="multiple"
                      selectionMode="single"
                      value={transformedData}
                      emptyMessage="Nenhuma Informação foi encontrada."
                      tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                    >
                      {columns.map((col) => (
                        <Column
                          sortable
                          key={col.field}
                          field={col.field}
                          header={col.header}
                          body={
                            col.field == "selfie" ||
                              col.field == "photo_doc" ||
                              col.field == "handwritten_signature"
                              ? (rowData) => (
                                <Checkbox
                                  checked={rowData[col.field]}
                                  onChange={() =>
                                    handleCheckboxChange(rowData, col.field)
                                  }
                                />
                              )
                              : col.body
                          }
                        />
                      ))}
                    </DataTable>
                  </div>
                </div>
              </AccordionTab>
            </Accordion>
            <div className="col-md-12 mt-4 align-self-end text-end">
              {" "}
              <Button
                rounded
                type="submit"
                loading={loading}
                iconPos="right"
                label="Salvar"
                icon="fa-solid fa-circle-chevron-right"
                className="p-inputtext-sm m-auto"
              />
            </div>
          </form>
        </>
      )}
    </>
  );
}
